export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/p3FmAYsk6VG2Z7JcrBAm6p/PAGINA_9.png',
    alt: 'Sample page Same Particles, Three Different Arrangements, comparing solids, liquids and gases with a property table and a common misconception',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fbCMHNrRhxzFFHrfpqy17j/PAGINA_21.png',
    alt: "Sample page Most of the Atom Is Empty Space, explaining Rutherford's gold-foil experiment and its conclusions",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aoeYsSudmEu479bhAWzhGW/PAGINA_29.png',
    alt: 'Sample page Why Chlorine Has a Mass of 35.5, a worked example of relative atomic mass with a key takeaway',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vR1jKQRfqGFUKh6hZmuGTy/PAGINA_36.png',
    alt: 'Sample page Write the Full Configuration, a table of spdf electron configurations for selected elements',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rKnPMwga9vjKDR1VJTsjHi/PAGINA_50.png',
    alt: 'Sample page Matter & Atomic Structure Field Card, a seven-section summary of the volume',
  },
];
